"use client";

import { Button } from "@/components/ui/button";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

export function Header() {
  const [isColor, setIsColor] = useState(false);

  useEffect(() => {
    const scrollContainer = document.querySelector(
      "#scroll-container"
    ) as HTMLElement;
    const anchorButton = document.querySelector(
      "#anchor-button"
    ) as HTMLElement;
    if (!scrollContainer || !anchorButton) return;

    const handleScroll = () => {
      const scrollPosition = scrollContainer.scrollTop;
      const anchorPosition = anchorButton.offsetTop;
      if (scrollPosition > anchorPosition) setIsColor(true);
      else setIsColor(false);
    };

    scrollContainer.addEventListener("scroll", handleScroll);

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className="sticky top-0 z-10 pl-5 pr-[10px] h-[60px] flex justify-between items-center border-b border-gray-200 bg-white">
      <Image
        src="https://qdltyctfafwvkilhjeln.supabase.co/storage/v1/object/public/website-assets/logo/logo_combo_primary.svg"
        alt="챗폼"
        width={60}
        height={25}
      />
      <div className="flex items-center gap-2">
        <Link href="/sign-up">
          <Button
            variant={isColor ? "gradient" : "secondary"}
            id="landing-inflow"
            className="transition-none"
          >
            무료로 시작하기
          </Button>
        </Link>
      </div>
    </header>
  );
}
